import { Component, Inject, Injector, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpErrorResponse } from '@angular/common/http';

import { PractitionerService } from 'app/core/http/services/practitioner.service';
import { DialogData } from 'app/core/interfaces/dialog';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { BlockDaysInterface } from './../../../../../../../core/interfaces/practitioner';

type DayType = 'blockSchedule' | 'holiday';

@Component({
  selector: 'blocked-day-dialog',
  templateUrl: './blocked-day-dialog.component.html',
  styleUrls: ['./blocked-day-dialog.component.scss'],
})
export class BlockedDayDialogComponent extends BaseComponent implements OnInit {
  public practitioner_id = '';
  public blockDays: any[] = []

  typeOptions: Array<{ value: DayType; label: string }> = [
    { value: 'holiday', label: 'Feriado' },
    { value: 'blockSchedule', label: 'Não trabalhado (bloquear agenda)' },
  ];

  form = this.fb.group({
    date: [null as Date | null, Validators.required],
    type: ['blockSchedule' as DayType, Validators.required],
  });

    private blockedSet: any

  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private practitionerService: PractitionerService,
    private dialogRef: MatDialogRef<BlockedDayDialogComponent>,
    private injector: Injector
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.practitioner_id = this.data?.param?.practitioner_id || '';
    this.blockDays = this.data?.param?.blockDays

    this.blockedSet = new Set<string>(
      this.blockDays.map(d => this.toYmdKey(new Date(d.date)))
    );

    
  }


  dateFilter = (d: Date | null): boolean => {
    if (!d) return true;
    const key = this.toYmdKey(d);
    return !this.blockedSet.has(key); // se está no Set, desabilita
  };

  private toYmdKey(date: Date): string {
    const safe = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12, 0, 0);
    const y = safe.getFullYear();
    const m = String(safe.getMonth() + 1).padStart(2, '0');
    const d = String(safe.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  addBlockDays(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    if (!this.practitioner_id) {
      this.snackBar.open('Practitioner inválido.', 'Fechar', {
        duration: 3500,
        verticalPosition: 'top',
      });
      return;
    }

    this.loading = true;

    const payload = this.form.getRawValue();

    this.practitionerService.blockDays(this.practitioner_id, payload).subscribe({
      next: (blockDays: BlockDaysInterface[]) => {
        this.loading = false;

        this.openSnackBar('Dia bloqueado com sucesso!', 'success');

        this.dialogRef.close(blockDays);
      },
      error: (error: HttpErrorResponse) => {
        this.loading = false;

        const msg =
          error?.error?.message || error?.message || 'Erro ao bloquear dia';

        this.showErrorMessage = true
        this.messageError = msg
      },
    });
  }

  close(): void {
    this.dialogRef.close(false);
  }
}
